import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {AntSwitch, FindLoad, Images} from "utils";
import {rmisActions} from "store";
import {Loader} from "components";

const ACTION_TYPE = 'GET_GO_HIGHWAY_UPDATES'

export const GoHighway = () => {
  const {goHighway} = useSelector((state) => ({
    goHighway: state.rmis.goHighway,
  }));
  const dispatch = useDispatch()
  const loader = FindLoad(ACTION_TYPE)
  const [highway, setHighway] = useState(false)

  useEffect(() => {
    dispatch(rmisActions.getGoHighway())
  }, [])

  useEffect(() => {
    if (goHighway) {
      setHighway(goHighway?.enableCron)
    }
  }, [goHighway])

  const handleSwitch = () => {
    setHighway(!highway)
    const sendInfo = {
      "enableCron": !highway,
    }
    dispatch(rmisActions.updateGoHighway(sendInfo))
  }

  if (loader?.length) {
    return <Loader/>
  }

  return (
    <div className='rmis-updates-wrapper'>
      <div className='rmis-tab-wrapper'>
        <div className='rmis-tab-image-text'>
          <img src={Images.highway} alt='icon'/>
          <p>GoHighway</p>
        </div>
        <AntSwitch
          onClick={() => handleSwitch()}
          checked={highway}
        />
      </div>
    </div>
  )
}